module.exports = __webpack_public_path__ + "static/hc2-layers-1bd721cd575bdc68a1f18590f2afc032.webm";